// src/components/CheckoutForm.jsx
import React from "react";
import { User, Trash2, Mail, Clipboard, X } from "lucide-react";
import NameAutocomplete from "./NameAutocomplete";

const CheckoutForm = ({
  catalogItems,
  items,
  usbDriveOption,
  setUsbDriveOption,
  name,
  setName,
  nameError,
  emailInput,
  handleEmailChange,
  handleClearEmail,
  emailError,
  notesInput,
  setNotesInput,
  setNotes,
  handleSubmit,
  handleClearCart,
  isSubmitting,
  setFocusedInput,
}) => {
  const hasCatalogItems = catalogItems.length > 0;
  const hasPhotoItems = items.length > 0;

  return (
    <form onSubmit={handleSubmit} className="checkout-form">
      {items.length > 0 && (
        <div className="form-group">
          <label>
            <input
              type="checkbox"
              checked={usbDriveOption}
              onChange={(e) => setUsbDriveOption(e.target.checked)}
            />
            Add USB Drive with Photos (+$10)
          </label>
        </div>
      )}

      <div className="form-group">
        <label htmlFor="notes">
          <Clipboard size={20} />
          Order Notes (Optional)
        </label>
        <textarea
          id="notes"
          value={notesInput}
          onChange={(e) => {
            setNotesInput(e.target.value);
            setNotes(
              usbDriveOption
                ? `${e.target.value}\n\nINCLUDE USB DRIVE (+$10)`
                : e.target.value
            );
          }}
          placeholder="Add any special instructions or notes"
          className="form-input"
          rows={3}
        />
      </div>

      {hasCatalogItems && (
        <div className="form-group">
          <label htmlFor="name">
            <User size={20} />
            Name
          </label>
          <NameAutocomplete
            value={name}
            onChange={setName}
            placeholder="Enter your name"
            className={nameError ? "error" : ""}
            error={nameError}
            disabled={isSubmitting}
          />
          {nameError && (
            <span className="error-message">{nameError}</span>
          )}
        </div>
      )}

      {hasPhotoItems && (
        <div className="form-group">
          <label htmlFor="email">
            <Mail size={20} />
            Email Address
          </label>
          <div className="email-input-wrapper">
            <input
              type="email"
              id="email"
              value={emailInput}
              onChange={handleEmailChange}
              onFocus={() => setFocusedInput && setFocusedInput('email')}
              onBlur={() => setFocusedInput && setFocusedInput(null)}
              placeholder="Enter your email"
              className={`form-input ${emailError ? "error" : ""}`}
              required
              disabled={isSubmitting}
            />
            {emailInput && (
              <button
                type="button"
                className="clear-email-btn"
                onClick={handleClearEmail}
                aria-label="Clear email"
                disabled={isSubmitting}
              >
                <X size={16} />
              </button>
            )}
          </div>
          {emailError && (
            <span className="error-message">{emailError}</span>
          )}
        </div>
      )}

      <div className="form-actions">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleClearCart}
          disabled={isSubmitting}
        >
          <Trash2 size={20} />
          Clear Cart
        </button>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={isSubmitting || (items.length === 0 && catalogItems.length === 0)}
        >
          {isSubmitting ? "Processing..." : "Submit Order"}
        </button>
      </div>
    </form>
  );
};

export default CheckoutForm;
